import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";

import Home from "./pages/Home";
import AdminPanel from "./pages/AdminPanel";
import AdminLogin from "./pages/AdminLogin"; // ✅ new
import RegistrationConfirm from "./pages/RegistrationConfirm";

import { Toaster } from "./components/ui/sonner";

function App() {
  // ✅ check token
  const [isAdmin, setIsAdmin] = useState(!!localStorage.getItem("admin_token"));

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route
            path="/admin"
            element={
              isAdmin ? (
                <AdminPanel />
              ) : (
                <AdminLogin onLogin={() => setIsAdmin(true)} />
              )
            }
          />

          <Route
            path="/registration-confirm"
            element={<RegistrationConfirm />}
          />
        </Routes>
      </BrowserRouter>

      <Toaster position="top-right" />
    </div>
  );
}

export default App;
